import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { safeUrl } from "@/lib/sanitize";

// Bandeau d'annonce global éditable (en-tête). Conserve l'en-tête existant :
// il s'ajoute simplement au-dessus. Rien ne s'affiche s'il est désactivé.
export default function SiteBanner() {
  const [banner, setBanner] = useState(null);
  useEffect(() => {
    api.get("/public/cms/settings/layout").then(({ data }) => setBanner(data?.banner || null)).catch(() => {});
  }, []);
  if (!banner || !banner.enabled || !banner.text) return null;
  const url = banner.href ? safeUrl(banner.href) : "";
  const inner = <span className="font-semibold">{banner.text}</span>;
  return (
    <div className="w-full text-center text-sm px-4 py-2" style={{ backgroundColor: banner.bg || "#172A3A", color: banner.color || "#ffffff" }} data-testid="site-banner">
      {url
        ? (url.startsWith("/")
            ? <Link to={url} className="hover:underline" data-testid="site-banner-link">{inner}</Link>
            : <a href={url} className="hover:underline" data-testid="site-banner-link">{inner}</a>)
        : inner}
    </div>
  );
}

// Note additionnelle éditable dans le pied de page (le pied existant est conservé).
export function SiteFooterNote() {
  const [note, setNote] = useState("");
  useEffect(() => {
    api.get("/public/cms/settings/layout").then(({ data }) => setNote(data?.footer_note || "")).catch(() => {});
  }, []);
  if (!note) return null;
  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 pb-6 text-xs text-white/60 whitespace-pre-line" data-testid="site-footer-note">{note}</div>
  );
}
